import DividerButton from "components/common/divider/button";
import moment from "moment-timezone";
import Image from "next/image";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import { useHandleImageErrorVer2 } from "utils/useHandleImageError";
import { useState } from "react";
import NewModal from "./NewModal";
import DividerLine from "components/common/divider/line";
import { TrackedList, TrackedListItem } from "lib/analytics/react/list";
import { TrackedModalProvider } from "lib/analytics/react/modal";

function InterestNewsRaderNews({ data }: { data: any }) {
  const router = useRouter();
  const { t } = useTranslation("main");
  const { getStockLogoSafe } = useHandleImageErrorVer2();
  const [isModalOpen, setModalOpen] = useState(false);
  const formatNewsDate = (d: string) =>
    router.locale === "ko"
      ? moment(d).format("M월 D일")
      : moment(d).format("MMM D");

  if (!data) return null;
  return (
    <div className="relative">
      <h2 className={`${TYPO.TYPO4_SB} text-gray80 px-6 pt-6`}>
        {t("latestStockNews")}
      </h2>
      <div className="px-6 pt-6">
        <TrackedList listId="watchlist_latest_news" totalCount={data?.length}>
          {data?.slice(0, 3)?.map((item: any, index: number) => (
            <TrackedListItem
              key={index}
              itemData={{
                kind: "newsrader",
                newsrader_id: item?.ID,
                ticker: item?.ITEM_CD_DL,
                rank: index + 1,
              }}
              className="cursor-pointer"
              href={`/detail/${item.ITEM_CD_DL}?tab=aireport`}
              data-gtm-id={`watchlist-newsrader-list`}
            >
              <div className="flex items-stretch ">
                <div className="w-[48px] flex flex-col  shrink-0 items-end">
                  <p
                    className={`text-gray60 ${TYPO.TYPO8_RG} whitespace-nowrap`}
                  >
                    {formatNewsDate(item.BASE_DT)}
                  </p>
                  <p
                    className={`${TYPO.TYPO8_RG} ${
                      Number(item?.ADJ_CLOSE_CHG?.toFixed(1)) === 0
                        ? "text-gray70"
                        : item?.ADJ_CLOSE_CHG > 0
                        ? "text-red40"
                        : "text-blue40"
                    }`}
                  >
                    {Number(item?.ADJ_CLOSE_CHG?.toFixed(1)) > 0 ? "+" : ""}
                    {item?.ADJ_CLOSE_CHG?.toFixed(1)}%
                  </p>
                </div>
                <div className="px-4">
                  <div
                    className="h-full w-[1px]  relative"
                    style={{
                      background:
                        index === 0
                          ? "linear-gradient(180deg, rgba(229, 232, 235, 0.00) 0%, #E5E8EB 100%)"
                          : index === data?.slice(0, 3)?.length - 1
                          ? "linear-gradient(180deg, #E5E8EB 0%, rgba(229, 232, 235, 0.00) 100%)"
                          : "var(--hairlineBorder)",
                    }}
                  />
                </div>
                <div className="flex flex-col gap-2 pb-[30px]">
                  <div className="flex gap-1 items-center">
                    <Image
                      src={getStockLogoSafe(item.ITEM_CD_DL)}
                      alt={item.ITEM_CD_DL}
                      width={18}
                      height={18}
                      className="rounded-[6px]"
                    />
                    <p
                      className={`${TYPO.TYPO8_MD} text-gray70 leading-[20px]`}
                    >
                      {item.ITEM_KR_NM}
                    </p>
                  </div>
                  <div className="flex gap-1 items-center flex-wrap">
                    <p
                      className={`${TYPO.TYPO7_1_MD} text-gray80 whitespace-pre-line`}
                    >
                      {item?.KEYWORD?.split(",").join("\n")}
                    </p>
                  </div>
                </div>
              </div>
            </TrackedListItem>
          ))}
        </TrackedList>
      </div>
      {data?.length > 3 ? (
        <DividerButton
          text={t("seeMore")}
          onClick={() => {
            setModalOpen(true);
          }}
          data-gtm-id={`watchlist-newsrader-more-btn`}
        />
      ) : (
        <DividerLine size="md" />
      )}

      <TrackedModalProvider
        modalId="watchlist_bs_newsrader"
        isOpen={isModalOpen}
        triggerSectionId="watchlist_latest_news"
        triggerType="user_click"
      >
        {isModalOpen && (
          <NewModal
            setModalOpen={setModalOpen}
            isModalOpen={isModalOpen}
            data={data}
          />
        )}
      </TrackedModalProvider>
    </div>
  );
}

export default InterestNewsRaderNews;
